// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-request-history {
  margin: 20px 0;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.history-header h3 {
  margin: 0;
  color: #e0e0e0;
}

.history-actions {
  display: flex;
  gap: 10px;
}

.process-button,
.refresh-button {
  padding: 8px 16px;
  border: 1px solid #444;
  border-radius: 4px;
  background: #3a3a3a;
  color: #e0e0e0;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.process-button:hover,
.refresh-button:hover {
  background: #4a4a4a;
  border-color: #555;
}

.process-button {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.process-button:hover {
  background: #0056b3;
  border-color: #0056b3;
}

.history-tabs {
  display: flex;
  border-bottom: 1px solid #444;
  margin-bottom: 20px;
}

.tab {
  padding: 10px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #999;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.tab:hover {
  color: #e0e0e0;
  background: #4a4a4a;
}

.tab.active {
  color: #007bff;
  border-bottom-color: #007bff;
  background: #2a2a2a;
}

.requests-content {
  min-height: 200px;
}

.no-requests {
  text-align: center;
  padding: 40px;
  color: #999;
}

.requests-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.request-item {
  border: 1px solid #444;
  border-radius: 6px;
  padding: 15px;
  background: #2a2a2a;
  transition: all 0.2s ease;
}

.request-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.request-item.pending {
  border-left: 4px solid #ffc107;
}

.request-item.processed {
  border-left: 4px solid #28a745;
}

.request-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.request-type {
  font-weight: 600;
  color: #e0e0e0;
  font-size: 16px;
}

.request-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.request-status.pending {
  background: #fff3cd;
  color: #856404;
}

.request-status.processed {
  background: #d4edda;
  color: #155724;
}

.request-status.error {
  background: #f8d7da;
  color: #721c24;
}

.request-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.request-key {
  font-size: 14px;
  color: #e0e0e0;
}

.request-info {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #999;
}

.request-info span {
  background: #3a3a3a;
  padding: 2px 6px;
  border-radius: 4px;
}

.request-error {
  background: #f8d7da;
  color: #721c24;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  border-left: 3px solid #dc3545;
  margin-top: 8px;
}

.request-last-response {
  background: #e2e3e5;
  color: #495057;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 11px;
  border-left: 3px solid #6c757d;
  word-break: break-all;
  max-height: 100px;
  overflow-y: auto;
  margin-top: 8px;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-link {
  background: none;
  border: none;
  color: #721c24;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  margin-left: 10px;
}

.button-link:hover {
  color: #491217;
}
`, "",{"version":3,"sources":["webpack://./src/containers/Licensing/LicenseRequestHistory.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".license-request-history {\n  margin: 20px 0;\n}\n\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.history-header h3 {\n  margin: 0;\n  color: #e0e0e0;\n}\n\n.history-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.process-button,\n.refresh-button {\n  padding: 8px 16px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  background: #3a3a3a;\n  color: #e0e0e0;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.process-button:hover,\n.refresh-button:hover {\n  background: #4a4a4a;\n  border-color: #555;\n}\n\n.process-button {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.process-button:hover {\n  background: #0056b3;\n  border-color: #0056b3;\n}\n\n.history-tabs {\n  display: flex;\n  border-bottom: 1px solid #444;\n  margin-bottom: 20px;\n}\n\n.tab {\n  padding: 10px 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #999;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.tab:hover {\n  color: #e0e0e0;\n  background: #4a4a4a;\n}\n\n.tab.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n  background: #2a2a2a;\n}\n\n.requests-content {\n  min-height: 200px;\n}\n\n.no-requests {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n.requests-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.request-item {\n  border: 1px solid #444;\n  border-radius: 6px;\n  padding: 15px;\n  background: #2a2a2a;\n  transition: all 0.2s ease;\n}\n\n.request-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.request-item.pending {\n  border-left: 4px solid #ffc107;\n}\n\n.request-item.processed {\n  border-left: 4px solid #28a745;\n}\n\n.request-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.request-type {\n  font-weight: 600;\n  color: #e0e0e0;\n  font-size: 16px;\n}\n\n.request-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.request-status.pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.request-status.processed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.request-status.error {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.request-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.request-key {\n  font-size: 14px;\n  color: #e0e0e0;\n}\n\n.request-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  font-size: 12px;\n  color: #999;\n}\n\n.request-info span {\n  background: #3a3a3a;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.request-error {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  border-left: 3px solid #dc3545;\n  margin-top: 8px;\n}\n\n.request-last-response {\n  background: #e2e3e5;\n  color: #495057;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 11px;\n  border-left: 3px solid #6c757d;\n  word-break: break-all;\n  max-height: 100px;\n  overflow-y: auto;\n  margin-top: 8px;\n}\n\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.button-link {\n  background: none;\n  border: none;\n  color: #721c24;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  margin-left: 10px;\n}\n\n.button-link:hover {\n  color: #491217;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
